<template>
  <div class="ml-sm-5">
    <request-service-approval
      v-if="isApproving"
      :academic-years="academicYears"
      :data="data"
      :is-read-only="isReadOnly"
      @cancel="onCancelHandler"
      @save="onSaveHandler($event)"
    />
    <request-service-cancel
      v-if="isCancelling"
      :data="data"
      :is-read-only="isReadOnly"
      @cancel="onCancelHandler"
      @save="onSaveHandler($event)"
    />
    <request-service-object
      v-if="isObjecting"
      :data="data"
      :is-read-only="isReadOnly"
      @cancel="onCancelHandler"
      @save="onSaveHandler($event)"
    />
    <request-service-return-to-previous-status
      v-if="isReturnToPreviousStatus"
      :data="data"
      :is-read-only="isReadOnly"
      :return-to-new-status="data.returnToNewStatus"
      @cancel="onCancelHandler"
      @save="onSaveHandler($event)"
    />
    <request-service-reconsideration
      v-if="isRequestReconsideration"
      :data="data"
      @cancel="onCancelHandler"
      @save="onSaveHandler($event)"
    />
  </div>
</template>
<script>
import RequestServiceCancel from './RequestServiceCancel.vue';
import RequestServiceApproval from './RequestServiceApproval.vue';
import RequestServiceObject from './RequestServiceObject.vue';
import RequestServiceReturnToPreviousStatus from './RequestServiceReturnToPreviousStatus.vue';

import requestHistoryViewDisplay from '@/utils/constants/requestHistoryViewDisplay.js';

import RequestServiceReconsideration from './RequestServiceReconsideration.vue';

export default {
  name: 'RequestServiceDetermination',
  components: {
    RequestServiceCancel,
    RequestServiceApproval,
    RequestServiceObject,
    RequestServiceReturnToPreviousStatus,
    RequestServiceReconsideration,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    academicYears: {
      type: Array,
      required: true,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    onCancelHandler() {
      this.$emit('cancel');
    },
    onSaveHandler(event) {
      this.$emit('save', event);
    },
  },
  computed: {
    isApproving() {
      return this.data.viewToDisplay === requestHistoryViewDisplay.APPROVE;
    },
    isCancelling() {
      return this.data.viewToDisplay === requestHistoryViewDisplay.CANCEL;
    },
    isObjecting() {
      return this.data.viewToDisplay === requestHistoryViewDisplay.OBJECT;
    },
    isReturnToPreviousStatus() {
      return (
        this.data.viewToDisplay ===
        requestHistoryViewDisplay.RETURN_TO_PREVIOUS_STATUS
      );
    },
    isRequestReconsideration() {
      return (
        this.data.viewToDisplay ===
        requestHistoryViewDisplay.REQUEST_RECONSIDERATION
      );
    },
  },
};
</script>
